export default __webpack_public_path__ + "static/media/Premier-Guaranteed-Star-Brochure.1ef26209.pdf";